import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { cassiopeiaIcons } from '@nestech/utils';
import { EnvironmentService } from '@web/service';
import { FooterActionComponent } from '../action/footer-action.component';

@Component({
  selector: 'cas-footer-actions',
  template: `
    <div class="row">
      <cas-footer-action
        class="col-8 col-md-auto"
        label="cas.getCounseling"
        subtitle="cas.bookMeeting"
        [icon]="icons.calendar"
        (click)="openMeeting()"></cas-footer-action>
      <cas-footer-action
        class="col-8 col-md-auto mt-3 mt-md-0"
        label="cas.writeMessage"
        subtitle="cas.writeMessageSubtitle"
        [icon]="icons.email"
        (click)="openContact()"></cas-footer-action>
      <cas-footer-action
        class="col-8 col-md-auto mt-3 mt-md-0"
        label="cas.callUs"
        [subtitle]="phone"
        [icon]="icons.phone"
        (click)="openPhone()" />
    </div>
  `,
  imports: [FooterActionComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterActionsComponent {
  #environment = inject(EnvironmentService).environment;
  #router = inject(Router);

  icons = cassiopeiaIcons;
  secureMail = this.#environment.contactInfo.secureMail;
  phone = this.#environment.contactInfo.phone;

  openContact() {
    this.secureMail ? window.open(this.secureMail, '_blank') : this.#router.navigate(['contact', 'form']);
  }
  openMeeting() {
    void this.#router.navigate(['contact']);
  }

  openPhone() {
    window.location.href = `tel:${this.phone}`;
  }
}
